export default __webpack_public_path__ + "static/media/transfer1.da3a4e1a.svg";